import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../../services/i18nService';

class MathWorkingMenu extends React.Component {
    static propTypes = {
        mathRowModel: PropTypes.object.isRequired,
        onAddRow: PropTypes.func,
        onDuplicateRow: PropTypes.func,
        onDeleteRow: PropTypes.func,
    };

    onAddRow = () => {
        this.props.onAddRow(this.props.mathRowModel);
    };

    onDuplicateRow = () => {
        this.props.onDuplicateRow(this.props.mathRowModel);
    };

    onDeleteRow = () => {
        this.props.onDeleteRow(this.props.mathRowModel);
    };

    render() {
        return (
            <div className="mathquill-ui-toolbar">
                <button
                    className="add-row"
                    onClick={this.onAddRow}
                    aria-label={t('interactions.mathWorking.addRow')}
                ><i className="fa fa-plus" />{t('interactions.mathWorking.addRow')}</button>
                <button
                    className="duplicate-row"
                    onClick={this.onDuplicateRow}
                    aria-label={t('interactions.mathWorking.duplicateRow')}
                ><i className="fa fa-copy" />{t('interactions.mathWorking.duplicateRow')}</button>
                <button
                    className="delete-row"
                    onClick={this.onDeleteRow}
                    aria-label={t('interactions.mathWorking.deleteRow')}
                ><i className="fa fa-trash" /></button>
            </div>
        );
    }
}

export default MathWorkingMenu;
